import { sortOptionsISelect } from "../helpers/sortISelect";
import { ICountry } from "../model/country.model";
import { ISelect } from "../model/iSelect";
import { ILocality } from "../model/locality.model";
import { IProvince } from "../model/province.model";

export const to_ISelect_Enum = (value: any, listItems: any[]): ISelect => {
  const dataFound = listItems.find((dataItem) => dataItem.value === value);  
  return dataFound;
};

export const to_ISelect_Entity = (
  item: ICountry | IProvince | ILocality
): ISelect | null => {
  const changed = item
    ? {
        value: item.id,
        label: item.name,
      }
    : null;
  return changed;
};

export const to_ISelect_Entity_Array = (
  items: ILocality[] | IProvince[] | ICountry[] | any[]
): ISelect[] | [] => {
  const data =
    items && items.length
      ? items.map((i: ILocality | IProvince | ICountry) => {
          return {
            value: i.id,
            label: i.name,
          };
        })
      : [];
  return sortOptionsISelect(data);
};

export const to_ICountry = (item: ISelect): ICountry | null => {
  const changed = item
    ? {
        id: item.value,
        name: item.label,
      }
    : null;

  return changed;
};

export const to_IProvince = (item: ISelect): IProvince | null => {
  const changed = item
    ? {
        id: item.value,
        name: item.label,
      }
    : null;

  return changed;
};

export const to_ILocality = (item: ISelect): ILocality | null => {
  const changed = item
    ? {
        id: item.value,
        name: item.label,
      }
    : null;

  return changed;
};
